(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("AIBotWidget", [], factory);
	else if(typeof exports === 'object')
		exports["AIBotWidget"] = factory();
	else
		root["AIBotWidget"] = factory();
})(self, () => {
return 